<template>
  <div class="add-new__level">
    <div class="vip-info pad-mar__title">
      <h3 class="title">会员基本信息</h3>
      <div class="input-wrapper">
        <el-form
          :inline="true"
          label-width="auto"
          label-position="left"
          :model="vipInfo"
        >
          <el-form-item>
            <span slot="label">
              <i class="red">*</i>
              会员等级名称：
            </span>
            <div class="input-box">
              <div class="input" style="width: 25rem">
                <el-input
                  v-model="vipInfo.levelName"
                  placeholder="请输入"
                  clearable
                />
              </div>
            </div>
          </el-form-item>
          <el-form-item>
            <span slot="label">
              <i class="red">*</i>
              开启自动升级：
            </span>
            <div class="input-box">
              <div class="input">
                <input
                  class="mui-switch mui-switch-animbg"
                  v-model="vipInfo.automationLevel"
                  type="checkbox"
                />
              </div>
            </div>
          </el-form-item>
          <span v-if="vipInfo.automationLevel">
            <el-form-item>
              <span slot="label">
                <i class="red">*</i>
                累积消费金额：
              </span>
              <div class="input-box">
                <div class="input" style="margin-bottom: 10px;">
                  <el-input
                    v-model="vipInfo.consume"
                    placeholder="请输入"
                    clearable
                  />
                </div>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">
                <i class="red">*</i>
                累积积分：
              </span>
              <div class="input-box">
                <div class="input" style="margin-bottom: 10px;">
                  <el-input
                    v-model="vipInfo.integral"
                    placeholder="请输入"
                    clearable
                  />
                </div>
              </div>
            </el-form-item>
          </span>
        </el-form>
      </div>
    </div>
    <div class="vip-feature pad-mar__title">
      <h3 class="title">会员功能设定</h3>
      <div class="input-wrapper">
        <el-form
          :inline="true"
          label-width="auto"
          label-position="left"
          :model="vipInfo"
        >
          <el-form-item>
            <span slot="label">
              <i class="red">*</i>
              折扣力度：
            </span>
            <div class="input-box">
              <div class="input" style="width: 25rem">
                <el-select
                  v-model="vipInfo.discount"
                  placeholder="请选择"
                  clearable
                >
                  <el-option
                    :value="item.value"
                    :label="`${item.label}折`"
                    v-for="item in filterDownData('discountList')"
                    :key="item.value"
                  />
                </el-select>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="vip-integral__discount  pad-mar__title">
      <div class="input-wrapper">
        <el-form
          :inline="true"
          label-width="auto"
          label-position="left"
          :model="vipInfo"
        >
          <el-form-item>
            <span slot="label">
              <i class="red">*</i>
              开启积分抵扣功能：
            </span>
            <input
              class="mui-switch mui-switch-animbg"
              v-model="vipInfo.integralDiscount"
              type="checkbox"
            />
          </el-form-item>
          <el-form-item v-if="vipInfo.integralDiscount">
            <span slot="label">
              <i class="red">*</i>
              积分抵扣：
            </span>
            <div class="input-box">
              <div class="input">
                <el-input
                  placeholder="请输入"
                  clearable
                  @blur="
                    replaceColon(
                      vipInfo.integralDiscountRatio,
                      'integralDiscountRatio'
                    )
                  "
                  v-model="vipInfo.integralDiscountRatio"
                />
              </div>
              <span class="tips">（例如:100:1为100积分抵1元）</span>
            </div>
          </el-form-item>
          <el-form-item v-if="vipInfo.integralDiscount">
            <span slot="label">
              <i class="red">*</i>
              单笔订单使用积分百分比：
            </span>
            <div class="input-box">
              <div class="input" style="width: 5rem">
                <el-input
                  placeholder="请输入"
                  v-model="vipInfo.orderRatio"
                  clearable
                />
              </div>
              %
              <span class="tips">（单笔订单所使用积分抵扣最大百分比）</span>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="vip-integral__accumulation pad-mar__title">
      <div class="input-wrapper">
        <el-form label-width="auto" label-position="right" :model="vipInfo">
          <el-form-item>
            <span slot="label">
              <i class="red">*</i>
              开启积分累积功能：
            </span>
            <input
              class="mui-switch mui-switch-animbg"
              v-model="vipInfo.integralAccumulation"
              type="checkbox"
            />
          </el-form-item>
          <span v-if="vipInfo.integralAccumulation">
            <el-form-item>
              <span slot="label">
                <i class="red">*</i>
                文字点评：
              </span>
              <div class="input-box">
                <div class="input">
                  <el-input
                    placeholder="请输入"
                    clearable
                    v-model="vipInfo.txtIntegral"
                  />
                </div>
                积分
                <span class="tips">
                  （文字点评所得积分）
                </span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">
                <i class="red">*</i>
                文字点评次数：
              </span>
              <div class="input-box">
                <div class="input">
                  <el-input
                    placeholder="请输入"
                    v-model="vipInfo.txtNum"
                    clearable
                  />
                </div>
                次数
                <span class="tips">
                  （每天文字点评次数）
                </span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">
                <i class="red">*</i>
                文字点评最少字数：
              </span>
              <div class="input-box">
                <div class="input">
                  <el-input
                    placeholder="请输入"
                    v-model="vipInfo.writeNum"
                    clearable
                  />
                </div>
                字数
                <span class="tips">
                  （文字点评字数）
                </span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">
                <i class="red">*</i>
                图文点评：
              </span>
              <div class="input-box">
                <div class="input">
                  <el-input
                    v-model="vipInfo.imgTxtIntegral"
                    clearable
                    placeholder="请输入"
                  />
                </div>
                积分
                <span class="tips">
                  （图文点评所得积分）
                </span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">
                <i class="red">*</i>
                图文点评次数：
              </span>
              <div class="input-box">
                <div class="input">
                  <el-input
                    v-model="vipInfo.imgTxtNum"
                    placeholder="请输入"
                    clearable
                  />
                </div>
                次数
                <span class="tips">
                  （图文点评次数）
                </span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">
                <i class="red">*</i>
                图文点评配图张数：
              </span>
              <div class="input-box">
                <div class="input">
                  <el-input
                    v-model="vipInfo.imgNum"
                    placeholder="请输入"
                    clearable
                  />
                </div>
                张数
                <span class="tips">
                  （ 图文点评配图张数）
                </span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">
                <i class="red">*</i>
                回复积分：
              </span>
              <div class="input-box">
                <div class="input">
                  <el-input
                    v-model="vipInfo.replyIntegral"
                    clearable
                    placeholder="请输入"
                  />
                </div>
                积分
                <span class="tips">
                  （每天最多获得3次被点评积分）
                </span>
              </div>
            </el-form-item>

            <el-form-item>
              <span slot="label">
                <i class="red">*</i>
                回复次数：
              </span>
              <div class="input-box">
                <div class="input">
                  <el-input
                    v-model="vipInfo.replyNum"
                    placeholder="请输入"
                    clearable
                  />
                </div>
                次数
                <span class="tips">
                  （每天最多回复次数）
                </span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">
                <i class="red">*</i>
                点赞：
              </span>
              <div class="input-box">
                <div class="input">
                  <el-input
                    v-model="vipInfo.likeIntegral"
                    clearable
                    placeholder="请输入"
                  />
                </div>
                积分
                <span class="tips">
                  （每天为其他会员的点评点赞可获得积分）
                </span>
              </div>
            </el-form-item>

            <el-form-item>
              <span slot="label">
                <i class="red">*</i>
                点赞获取积分次数：
              </span>
              <div class="input-box">
                <div class="input">
                  <el-input
                    v-model="vipInfo.likeNum"
                    placeholder="请输入"
                    clearable
                  />
                </div>
                次数
                <span class="tips">
                  （每天为其他会员的点评点赞可获得积分）
                </span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">
                <i class="red">*</i>
                消费积分比例：
              </span>
              <div class="input-box">
                <div class="input">
                  <el-input
                    @blur="replaceColon(vipInfo.salesRatio, 'salesRatio')"
                    v-model="vipInfo.salesRatio"
                    clearable
                    placeholder="请输入"
                  />
                </div>
                积分
                <span class="tips">
                  （例如:1:1为每消费1元积1分）
                </span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">
                <i class="red">*</i>
                充值送积分比例：
              </span>
              <div class="input-box">
                <div class="input">
                  <el-input
                    @blur="replaceColon(vipInfo.rechargeRatio, 'rechargeRatio')"
                    clearable
                    v-model="vipInfo.rechargeRatio"
                    placeholder="请输入"
                  />
                </div>
                积分
                <span class="tips">
                  （例如：1:1表示充多少金额送多少积分）
                </span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">
                <i class="red">*</i>
                完善个人信息：
              </span>
              <div class="input-box">
                <div class="input">
                  <el-input
                    v-model="vipInfo.perfectingIntegral"
                    clearable
                    placeholder="请输入"
                  />
                </div>
                积分
                <span class="tips">
                  （首次完善有效）
                </span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">
                <i class="red">*</i>
                签到：
              </span>
              <div class="input-box">
                <div class="input">
                  <el-input
                    v-model="vipInfo.checkInIntegral"
                    clearable
                    placeholder="请输入"
                  />
                </div>
                积分
                <span class="tips">
                  （每天一次）
                </span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">
                <i class="red">*</i>
                签到获取积分次数：
              </span>
              <div class="input-box">
                <div class="input">
                  <el-input
                    v-model="vipInfo.checkInNum"
                    placeholder="请输入"
                    clearable
                  />
                </div>
                次数
                <span class="tips">
                  （每天签到获取积分）
                </span>
              </div>
            </el-form-item>
          </span>
        </el-form>
      </div>
    </div>
    <el-button
      @click="saveVipInfo"
      size="120"
      class="sub-color save"
      v-permission:save="$route.meta.permission"
      v-html="'保存'"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import filterDownData from 'mixins/filterDownData'
const { mapGetters, mapMutations } = createNamespacedHelpers('vipLevel')
export default {
  name: 'addNewLevel',
  mixins: [filterDownData],
  data() {
    this.keyMap = {
      vipInfo: {
        name: 'data',
        id: 'level_id',
        levelName: 'level_name',
        consume: 'consume_sum',
        integral: 'cumulative_integral',
        discount: 'discount_id',
        automationLevel: 'auto_update',
        txtIntegral: 'written_comment_points',
        imgTxtIntegral: 'imagetext_comment_points',
        integralAccumulation: 'integral_accumulation',
        replyIntegral: 'reply_points',
        likeIntegral: 'like_points',
        checkInIntegral: 'sign_points',
        salesRatio: 'consumption_integral_proportion',
        rechargeRatio: 'recharge_integral_proportion',
        perfectingIntegral: 'perfecting_information_points',
        integralDiscount: 'integral_deduction',
        integralDiscountRatio: 'points_deduction_integral_proportion',
        txtNum: 'written_comment_number',
        imgTxtNum: 'imagetext_comment_number',
        imgNum: 'imagetext_sheets_number',
        writeNum: 'written_number',
        replyNum: 'reply_number',
        likeNum: 'like_number',
        checkInNum: 'sign_number',
        orderRatio: 'deduction_ration'
      }
    }
    return {
      vipInfo: {}
    }
  },
  created() {
    const id = this.$route.query.id
    if (id) {
      this._getVipLevelList(id)
    }
  },
  computed: {
    ...mapGetters({
      info: 'getVipLevel'
    })
  },
  beforeRouteUpdate(to, from, next) {
    this._getVipLevelList(to.query.id)
    next()
  },
  methods: {
    ...mapActions(['_getAllDownData']),
    /**
     * 从store获取会员等级信息
     * @private
     */
    _getVipLevelList(params) {
      this.vipInfo = this.info(params)
    },
    /**
     * 处理中文：
     * @param value
     * @param str
     */
    replaceColon(value, str) {
      this.vipInfo[str] = value.replace(/：/g, ':')
    },
    /**
     * 保存会员信息
     */
    saveVipInfo() {
      const info = {
        vipInfo: {}
      }
      Object.assign(info.vipInfo, this.vipInfo)
      this.utils._modifyObjKey(info, this.keyMap)
      info.data.auto_update = info.data.auto_update ? 1 : 0
      info.data.integral_deduction = info.data.integral_deduction ? 1 : 0
      info.data.integral_accumulation = info.data.integral_accumulation ? 1 : 0
      this.api.saveVipLevel(info.data).then(() => {
        this.$notify({
          type: 'success',
          message: '保存成功~！'
        })
        this._getAllDownData() // 更新全局的会员等级信息
      })
    }
  }
}
</script>

<style lang="scss">
.add-new__level {
  .vip-info,
  .vip-feature {
    width: calc(50% - 0.65rem);
    min-height: 27.5rem;
    display: inline-block;
    @include maxScreenWidth(1480) {
      width: 100%;
      height: auto;
      margin: 0 0 1.3rem 0 !important;
    }
  }

  .vip-info {
    margin-right: 0.65rem;
  }

  .vip-feature {
    margin-left: 0.65rem;
  }

  .vip-integral__discount {
    min-height: 8.8rem;
  }

  .tips {
    color: #a4a4a4;
    margin-left: 1rem;
  }

  .vip-integral__accumulation {
    min-height: 50rem;
  }

  .save {
    border-radius: initial;
    position: relative;
    left: 50%;
    margin-left: -60px;
  }
}
</style>
